import { Icon } from "@mdi/react";
import { useState } from "react";
import { useSelector } from "react-redux";

import { mdiFolderPlus } from "@mdi/js";
import { Tooltip } from "antd";
import { RootState } from "store/rootReducer";
import styled from "styled-components";

import {
  ActionButton,
  FlexItem
} from "components/project/layers/components/layer-managers/shared";
import { SHAPEFILE_FOLDER_TYPE } from "components/project/layers/hooks/project-layer-tree/useProjectLayerTree.types";
import { useCreateProjectShapefileFolder } from "components/project/shapefiles/hooks/createProjectShapefileFolder/useCreateProjectShapefileFolder";

export default function OrgRootNode({ node }) {
  const role = useSelector((state: RootState) => state.auth.user.role);
  const isAdminOrPowerUser = role === "Admin" || role === "PowerUser";
  const [tempFoldersLength, setTempFoldersLength] = useState(0);

  const createProjectFolder = useCreateProjectShapefileFolder({
    projectId: SHAPEFILE_FOLDER_TYPE.ORGANIZATION
  });

  const handleCreateFolder = async (evt) => {
    evt.stopPropagation();
    evt.preventDefault();

    setTempFoldersLength((prev) => prev + 1);

    try {
      await createProjectFolder.mutateAsync({
        parentId: "orgLevelShapefiles",
        order: node.children.length + tempFoldersLength
      });
    } finally {
      setTempFoldersLength((prev) => prev - 1);
    }
  };

  return (
    <NodeTitle className="visible-always">
      <FlexItem>
        <label>{node.title}</label>
      </FlexItem>
      {isAdminOrPowerUser && (
        <FlexItem>
          <Tooltip placement="top" title="Create New Folder">
            <ActionButton onClick={handleCreateFolder}>
              <Icon path={mdiFolderPlus} size={1} />
            </ActionButton>
          </Tooltip>
        </FlexItem>
      )}
    </NodeTitle>
  );
}

const NodeTitle = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto auto auto;
  align-items: center;
  justify-content: space-between;

  ${ActionButton} {
    svg {
      opacity: 0;
    }
  }

  border: ${(props) => (props.canDrop ? "1px dashed green" : "none")};

  &:hover,
  &.visible-always,
  &.in-edit-mode {
    svg {
      opacity: 1;
    }
  }
`;
